import Pager from "../libraries/Pager.js";

export default function init() {
  const blocks = document.querySelectorAll(
    ".page-part-products-overview .content, .page-part-be-inspired-overview .content"
  );

  blocks.forEach((element) => {
    handleBlock(element);
  });
}

/**
 * @param { HTMLElement } block
 */
function handleBlock(block) {
  const loadMoreButton = block.querySelector(".load-more .button-primary");
  const loadMoreContainer = block.querySelector(".load-more");
  const container = block.querySelector(".entries");

  const newItemsPerPage = parseInt(
    container.getAttribute("data-items-per-page")
  );
  const totalItems = parseInt(container.getAttribute("data-items-total"));
  const baseUrl = container.getAttribute("data-items-url");
  const params = container.getAttribute("data-items-params") || ""; // TODO if the string == "false" this still evaluteats to false but whatever.

  let offset = container.children.length;

  if (offset >= totalItems) {
    loadMoreContainer.classList.add("hidden");
  }

  let pager = new Pager({
    container: container,
  });

  pager.addEventListener("appendbefore", () => {
    loadMoreContainer.classList.add("loading");
  });
  pager.addEventListener("appendafter", () => {
    loadMoreContainer.classList.remove("loading");
  });

  loadMoreButton.addEventListener("click", (event) => {
    event.preventDefault();

    let url = baseUrl;

    url += "?";
    url += params;
    url += "&";
    url += "offset=" + offset;
    url += "&";
    url += "count=" + newItemsPerPage;

    offset += newItemsPerPage;

    if (offset >= totalItems) {
      loadMoreContainer.classList.add("hidden");
    }

    pager.append(url);
  });
}
